export function browserValidation() {
  let version = detectIE();
  if (!version || version < 9) {
    return getErrorMessage("109");
  }
}

function detectIE() {
  let ua = window.navigator.userAgent;
  let msie = ua.indexOf("MSIE ");
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
  }

  let trident = ua.indexOf("Trident/");
  if (trident > 0) {
    // IE 11 => return version number
    let rv = ua.indexOf("rv:");
    return parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
  }

  let edge = ua.indexOf("Edge/");
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf(".", edge)), 10);
  }

  edge = ua.indexOf("Edg/");
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 4, ua.indexOf(".", edge)), 10);
  }

  // other browser
  return false;
}

export const getErrorMessage = (env) => {
  if (env === "101") {
    return "User Not Found: We are unable to find this user in our UserStore.";
  } else if (env === "102") {
    return "Invalid SSO Message: Invalid Request sent by the IDP is incorrect.";
  } else if (env === "103") {
    return "Unaccepted User Credential (SSO Message)";
  } else if (env === "104") {
    return "Server Error: Error occured while processing request. Please contact common service team for more information";
  } else if (env === "105") {
    return "Invalid Request: Bad Request";
  } else if (env === "106") {
    return "Unauthorized Access: User is not authorized";
  } else if (env === "107") {
    return "Unauthorized Access: Domain is not authorized";
  } else if (env === "108") {
    return "Invalid parameters: The parameters sent not recognized by landing page";
  } else if (env === "109") {
    return "Drive requires Internet Explorer 9.0 or greater. Please re-launch Drive using Internet Explorer 9.0 or greater.";
  } else if (env === "500") {
    return "Internal Error occured. Please contact cdk support";
  } else if (env === "5401") {
    return "Invalid Request/Session Expired. Try login again.";
  }
}
